import { render } from "./ListSupplierInvoicesActionButtonsRenderer.vue?vue&type=template&id=2f27d0ba"
import script from "./ListSupplierInvoicesActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListSupplierInvoicesActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__